import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/code-block.vue
var o = {
	name: "DtIconCodeBlock",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--code-block"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Code Block",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [...t[0] || (t[0] = [r("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M2.54 2.04a.5.5 0 0 0-.5.5v6.92a.5.5 0 0 0 .5.5h6.92a.5.5 0 0 0 .5-.5V6.75a.5.5 0 0 1 1 0v2.71a1.5 1.5 0 0 1-1.5 1.5H2.54a1.5 1.5 0 0 1-1.5-1.5V2.54a1.5 1.5 0 0 1 1.5-1.5h.21a.5.5 0 1 1 0 1h-.21Zm4.064-.594a.5.5 0 0 1 0 .707L5.23 3.527 6.604 4.9a.5.5 0 0 1-.707.707L4.17 3.88a.5.5 0 0 1 0-.707l1.727-1.727a.5.5 0 0 1 .707 0Zm1.776 0a.5.5 0 0 1 .707 0l1.727 1.727a.5.5 0 0 1 0 .707L9.087 5.607A.5.5 0 0 1 8.38 4.9l1.374-1.373L8.38 2.153a.5.5 0 0 1 0-.707Z",
		fill: "currentColor"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=code-block.js.map